import { jsx as m } from "@emotion/react/jsx-runtime";
import { useContext as j, createContext as v, useState as T, useCallback as r, useMemo as x } from "react";
const C = v(void 0), p = ({
  children: c,
  selectable: u
}) => {
  const [n, o] = T({}), a = r((t) => (o((e) => ({
    ...e,
    [t]: !1
  })), () => {
    o((e) => {
      const {
        [t]: s,
        ...l
      } = e;
      return l;
    });
  }), []), d = x(() => {
    const t = Object.keys(n).length;
    if (!t)
      return !1;
    const e = Object.values(n).reduce((s, l) => s + (l ? 1 : 0), 0);
    return e === 0 ? !1 : t === e ? !0 : "indeterminate";
  }, [n]), i = r(() => {
    o((t) => Object.keys(t).reduce((e, s) => ({
      ...e,
      [s]: !0
    }), {}));
  }, []), b = r(() => {
    o((t) => Object.keys(t).reduce((e, s) => ({
      ...e,
      [s]: !1
    }), {}));
  }, []), f = r((t) => {
    o((e) => ({
      ...e,
      [t]: !0
    }));
  }, []), w = r((t) => {
    o((e) => ({
      ...e,
      [t]: !1
    }));
  }, []), R = x(() => ({
    registerSelectableRow: a,
    selectedRowIds: n,
    selectRow: f,
    unselectRow: w,
    selectable: u,
    selectAll: i,
    unselectAll: b,
    allRowSelectValue: d
  }), [a, n, f, w, u, i, b, d]);
  return /* @__PURE__ */ m(C.Provider, { value: R, children: c });
}, O = () => {
  const c = j(C);
  if (!c)
    throw new Error("useTableContext should be used inside a Table component");
  return c;
};
export {
  p as TableProvider,
  O as useTableContext
};
